/* eslint-disable prefer-promise-reject-errors */
import config from 'src/config';
import { postRequest, putRequest } from 'src/utils/RequestUtil';

export const targetSearchAPI = function (data) {
    const url = `${config.baseUrl}target/search`;
    return postRequest({
        url,
        data,
    });
};

export const targetCreateAPI = function (data) {
    const url = `${config.baseUrl}target`;
    console.log('url', url)
    return postRequest({
        url,
        data,
    });
};

export const targetUpdateAPI = function ({
    targetId,
    data,
}) {
    const url = `${config.baseUrl}target/${targetId}`;
    return putRequest({
        url,
        data,
    });
};
